export const DASHBOARD_TABS = ['overview', 'contacts', 'leads', 'invoices', 'estimates', 'analytics', 'bot'];

export function normalizeAdminTab(tab) {
  const nextTab = String(tab || '').replace(/^#/, '');
  return DASHBOARD_TABS.includes(nextTab) ? nextTab : 'overview';
}

export function toDateKey(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 10);
}
